/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ shown: NonNullable<unknown>, total: NonNullable<unknown> }} Players_Filtered_CountInputs */



/**
* | output |
* | --- |
* | "{shown} of {total} shown" |
*
* @param {Players_Filtered_CountInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const players_filtered_count = /** @type {((inputs: Players_Filtered_CountInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Players_Filtered_CountInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`${i?.shown} sur ${i?.total} affichés`)
	if (locale === "es") return /** @type {LocalizedString} */ (`${i?.shown} de ${i?.total} mostrados`)
	if (locale === "pt") return /** @type {LocalizedString} */ (`${i?.shown} de ${i?.total} exibidos`)
	if (locale === "it") return /** @type {LocalizedString} */ (`${i?.shown} di ${i?.total} mostrati`)
	return /** @type {LocalizedString} */ (`${i?.shown} of ${i?.total} shown`)
});